import { useEffect, useState } from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import {
  GlobeAltIcon,
  Squares2X2Icon,
  CheckCircleIcon,
} from "@heroicons/react/24/solid";
import { ArrowLeftEndOnRectangleIcon } from "@heroicons/react/24/outline";
import { logout } from "../../Services/authService";
import { Shield, ShieldAlertIcon, ShieldCheck } from "lucide-react";

export default function SessionExpired() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#000e22] to-[#084298] px-4">
      <div className="bg-white w-full border-t-[12px] border-t-blue-500  max-w-lg rounded-2xl shadow-2xl p-8 text-center">
        <style jsx>
          {`
            .shield::before {
              position: absolute;
              top: 16px;
              left: 16px;
              content: "";
              width: 50%;
              height: 50%;
              border-radius: 100%;
              opacity: 0;
              animation: sdb03 2s infinite;
              box-sizing: border-box;
              z-index: 9999;
              animation: shieldAnimation 3s infinite alternate-reverse;
            }

            @keyframes shieldAnimation {
              0% {
                opacity: 1;
              }
              30% {
                opacity: 1;
              }
              60% {
                box-shadow: 0 0 0 40px rgba(0, 132, 255, 0.189);
                opacity: 1;
              }
              100% {
                opacity: 1;
              }
            }
          `}
        </style>
        <div className="w-full flex justify-center my-4 ">
          <img
            alt="logo"
            className="w-40 h-auto"
            src="/media/logo/idspay_horizontal_blue.png"
          />
        </div>

      <div className="w-full flex justify-center my-4">
          <div className="  shield relative  ">
          <ShieldAlertIcon
            fill="#3475EF"
            strokeWidth={1}
            size={70}
            className="text-white  "
          />
        </div>
      </div>

       <div  className="w-full flex justify-center ">
         <h1 className="text-2xl border-l-8 border-l-blue-500 rounded-l-md font-bold pl-2 text-slate-900  my-4">
          Session Expired
        </h1>
       </div>

        <p className="text-sm text-slate-600 mb-3">
          For your security, you have been logged out due to inactivity.
        </p>

        {/* Common Reasons */}
        <div className="bg-[#EEF4FF] rounded-xl p-4 text-left mb-6">
          <h3 className="text-sm font-semibold text-[#084298] mb-3">
            Common Reasons for Logout
          </h3>

          <ul className="space-y-2 text-sm text-slate-700">
            {[
              "Prolonged inactivity",
              "Login from another device",
              "Cookies or cache cleared",
              "Security or policy update",
              "When you click Logout Button"
            ].map((reason, index) => (
              <li key={index} className="flex items-center gap-2">
                <CheckCircleIcon className="w-4 h-4 text-[#0B5ED7]" />
                {reason}
              </li>
            ))}
          </ul>
        </div>

        {/* Buttons */}
        <div className="space-y-3">
          <a
            href="/"
            className="flex items-center justify-center gap-2 w-full bg-[#0B5ED7] hover:bg-[#084298] text-white font-semibold py-3 rounded-xl transition"
          >
            <ArrowLeftEndOnRectangleIcon className="w-5 h-5" />
            Login Again
          </a>

        <div className="flex items-center justify-center gap-4">
            <a
            href="https://idspay.in"
            target="_blank"
            className="flex items-center justify-center gap-2 w-full border border-slate-300 hover:bg-slate-200 text-slate-900/80 font-semibold py-3 rounded-xl transition"
          >
            <GlobeAltIcon className="w-5 h-5" />
            Visit Website
          </a>

          <a
            href="https://idspay.in/idspay-api-service"
            target="_blank"
            className="flex items-center justify-center gap-2 w-full border border-slate-300 hover:bg-slate-200 text-slate-900/80 font-semibold py-3 rounded-xl transition"
          >
            <Squares2X2Icon className="w-5 h-5" />
            Product Catalog
          </a>
        </div>
        </div>

        <p className="text-xs text-slate-500 mt-6">
          © 2026 IDSPay • Secure • Reliable • Trusted
        </p>
      </div>
    </div>
  );
}
